import { shouldMaskPhoneNumbers } from 'src/plugins/helpers/phone-masking'

export default {
  loading (state) {
    return state.loading
  },
  profile (state) {
    return state.profile
  },
  authenticated (state) {
    return state.authenticated
  },
  user (state) {
    return { profile: state.profile, authenticated: state.authenticated }
  },
  isTrial (state) {
    return state.profile?.company?.is_trial
  },
  isTalkLite (state) {
    return state.is_focused_power_dialer
  },
  shouldMaskPhoneNumbers (state, getters, rootState) {
    return shouldMaskPhoneNumbers(rootState.cache?.currentCompany, state.profile?.user_roles)
  }
}
